/*
  customsirge_infused_notice.js
  Purpose:  Opens the temporary "Gigli Infused has moved" <dialog>
            (snippets/customsirge_infused_notice.liquid) once per visitor every
            N days, or once per visit when N is 0 (sessionStorage: it shows
            again the next time they come to the site, not on every page),
            and closes it on the close/stay buttons, Escape or a
            backdrop click. The copy button puts the Infused address on the
            clipboard (no link to the THC site). Not shown inside the theme editor's design mode
            unless the setting is being edited.
*/
(function () {
  'use strict';
  if (!window.Customsirge || !window.Customsirge.register) return;

  var KEY = 'customsirge_infused_notice_seen';

  var everyVisit = false;
  function store() {
    return everyVisit ? window.sessionStorage : window.localStorage;
  }
  function seenRecently(days) {
    try {
      var t = parseInt(store().getItem(KEY), 10);
      if (everyVisit) return !!t;
      return t && Date.now() - t < days * 86400000;
    } catch (e) {
      return false;
    }
  }
  function markSeen() {
    try { store().setItem(KEY, String(Date.now())); } catch (e) {}
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(area);
      if (ok) { resolve(); } else { reject(); }
    });
  }

  window.Customsirge.register('infused-notice', {
    selector: '[data-customsirge-infused-notice]',
    init: function (dialog) {
      var days = parseInt(dialog.getAttribute('data-days'), 10);
      if (isNaN(days)) days = 7;
      everyVisit = days === 0;
      var close = function () { markSeen(); if (dialog.open) dialog.close(); };

      dialog.addEventListener('click', function (evt) {
        if (evt.target === dialog || evt.target.closest('[data-infused-notice-close]')) close();
        if (evt.target.closest('[data-infused-notice-go]')) markSeen();
        var copyBtn = evt.target.closest('[data-infused-notice-copy]');
        if (copyBtn) {
          var label = copyBtn.getAttribute('data-label') || copyBtn.textContent;
          copyBtn.setAttribute('data-label', label);
          var status = dialog.querySelector('[data-infused-notice-status]');
          copyText(copyBtn.getAttribute('data-infused-notice-copy')).then(function () {
            var done = copyBtn.getAttribute('data-copied-label');
            copyBtn.textContent = done;
            if (status) status.textContent = done;
            window.setTimeout(function () {
              copyBtn.textContent = label;
              if (status) status.textContent = '';
            }, 2000);
          }, function () {});
        }
      });
      dialog.addEventListener('cancel', markSeen);

      if (seenRecently(days) || typeof dialog.showModal !== 'function') return;
      window.setTimeout(function () { if (!dialog.open) dialog.showModal(); }, 800);
    }
  });
})();
